import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";


const fieldsConfig = {

    'replyByDefault': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : false,
        options         : [true, false]
    },
    'emailTemplateId': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : undefined,
        // options         : ['default','small']
    }
}

export default class ProjectSettings_IntegrationEmailReply extends ServerSettings {

    public replyByDefault   : boolean
    public emailTemplateId? : ID

    constructor(config: any) {
        super(config, fieldsConfig);

        this.replyByDefault     = this.initValue('replyByDefault')
        this.emailTemplateId       = this.initValue('emailTemplateId')
    }

    toJson() {

        const result = {};

        this.valueToJson(result, 'replyByDefault')
        this.valueToJson(result, 'emailTemplateId')

        return result;
    }
}
